import React from "react";

import { Card, Row, Col
  } from "reactstrap";

var Utils = require ('Utils');
var Const = require ('Const');

export const  TutorCard = ( { tutor } ) => { 
    return (
        <>
        {tutor && 
          <div> 
            <Card className="card-user" style={{backgroundColor: "rgb(236 234 234)", padding: '15px'}}>
              <Row>
                <Col   md="4">
                  <img
                      alt="..."
                      className="avatar border-gray"
                      src={tutor.image?tutor.image:Const.DEFAULT_IMAGE_PROFILE[(tutor.gender?tutor.gender:'O')]}
                      />
                </Col>

                <Col className="pl-1" md="8">
                  <p className="h5"> {Utils.capitalize(tutor.last_name + ", " + tutor.name)} </p>
                  <p className="h5"> {tutor.doc_type + ": " + tutor.doc_nbr} </p>
                </Col>

              </Row>
              </Card>
            </div>
            }
        </>
    );
  }


